import React, { useEffect, useState } from "react";
import { useAppDispatch as useDispatch } from "src/core/redux/hooks";
import { setPageTitle, removeInfoMessage } from "src/core/redux";
import { SentinelPageProps } from "src/web/interfaces";
import { SentinelBasePage } from "src/web/pages/sentinel-base";
import { Alert, Button } from "@cloudscape-design/components";
import { getPackageDependencyList } from "src/core/sentinel/actions";
import { SentinelController } from "src/core/controller";
import { PackageDependency } from "src/core/sentinel/types";
import { DependencyTable } from "src/web/components/DependencyTable";

import { useParams, useNavigate } from "react-router-dom";
export interface SentinelPackageDetailPageProps extends SentinelPageProps {
  readOnly?: boolean;
  sentinelController: SentinelController;
}
export const PackageDetailPage: React.FC<SentinelPackageDetailPageProps> = (
    // eslint-disable-next-line
  props: SentinelPackageDetailPageProps
) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [dependencyList, setDependencyList] = useState<PackageDependency[]>([]);
    const { packageId } = useParams<{ packageId: string }>();
    useEffect(() => {
        const fetchDependencyList = async () => {
            setError("");
            if (!packageId) return;
            try {
                const response: any = await dispatch(
                    getPackageDependencyList({
                        sentinelController: props.sentinelController,
                        packageDependencyListInput: { packageName: packageId },
                    })
                ).unwrap();
                const list = response?.payload?.packageDependencyList;
                setDependencyList(Array.isArray(list) ? list : []);
            } catch (error) {
                setError("Failed to load package dependencies.");
            }
            setLoading(false);
        };
        fetchDependencyList();
    }, [packageId]);

    useEffect(() => {
        dispatch(setPageTitle("Package Detail"));
        dispatch(removeInfoMessage({ id: "message_1" }));
    }, []);

    return (
        <SentinelBasePage>
            {error && <Alert type="error" dismissible onDismiss={() => setError("")}>{error}</Alert>}
            <DependencyTable
                key={packageId}
                items={dependencyList}
                headerTitle={`Dependencies for package: ${packageId}`}
                showMajorVersionUpgradeInfo
                loading={loading}
                headerActions={
                    <Button variant="link" onClick={() => navigate(-1)}>
            ← Back to Packages
                    </Button>
                }
            />
        </SentinelBasePage>
    );
};
